<template>
  <div class="grade-grid-screen text-left px-3 py-4">
    <div v-if=" item.id != undefined ">
      <div class="col-12">
        <label>Nome da Aula</label>
        <input class="form-control input-form-course " v-model="item.name" />
      </div>
      <hr />
      <div v-if="!item.module">
        <media-item title="Capa da aula" modal="uploadCoverModal" @setItemValue="setCover" :itemDefault="item.cover" />
        <hr />
        <media-item title="Vídeo" modal="uploadVideoModal" @setItemValue="setVideo" :itemDefault="item.video" />
        <hr />
        <media-item title="Midias para Download" modal="uploadMediasModal" @setItemValue="setMedia" :itemDefault="item.media" />
        <hr />
      </div>
      <div class="col-12">
        <label>Descrição da Aula</label>
        <textarea class="form-control input-form-course" v-model="item.description" rows="3"/>
      </div>
      <hr />
      <div class="col-12 d-flex justify-content-between">
        <button class="btn btn-sm btn-primary" @click="save">Salvar</button>
        <button class="btn btn-sm btn-danger" @click="remove">Excluir</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MediaItem from './../../../Media/LoadItemMedia'

export default {
  name: "add-course-grade-screen",
  props: {
    currentClass: {
      required: true,
      type: Object,
    },
  },
  watch: {
    currentClass: {
      immediate: true,
      handler(val, old) {
        if ( val != old ) {
          this.item = Object.assign({}, val)
        }
      }
    }
  },
  components: {
    'media-item': MediaItem
  },
  data () {
    return {
      item: {}
    }
  },
  methods: {
    ...mapActions({
      removeModule: "removeModule",
      saveData: "saveClass"
    }),

    remove: function () {
      this.removeModule( this.item )
      this.item = {}
    },

    save: function () {
      this.saveData( this.item )
    },

    setCover: function ( value ) {
      this.item.cover = value
    },

    setVideo: function (value ) {
      this.item.video = value
    },

    setMedia: function (value ) {
      this.item.media = value
    },
  }
}
</script>
